import Vue from 'vue'
import Router from 'vue-router'

import CreateSmallInstitution from '@/views/create/CreateSmallInstitution.vue'
//common
import RoutePath from '@/utils/modules/RoutePath'
import { setToken, isLogin } from '@/utils/modules/Common'

//common
import userAPI from '@/services/api/institute/user'
import PageName from '@/utils/defines/PageName'
import InviteRoutes from '@/router/invite'
import CargoRoutes from './cargo'
Vue.use(Router)

let routes = [
	// {
	//     path: '/',
	//     name: 'Home',
	//     component: () => import('@/views/Home.vue'),
	// },
	// {
	//     path : "*",
	//     redirect: to => {
	//         return { path: '/' }
	//     },
	// },
	{
		path: '/createInstitution',
		name: 'createInstitution',
		component: CreateSmallInstitution,
	},
	{
		path: RoutePath.user.main,
		name: PageName.User.Main,
		component: () => import('@/views/user/MyPage.vue'),
	},
	{
		path: RoutePath.user.name,
		name: PageName.User.Name,
		component: () => import('@/views/user/UserChangeName.vue'),
	},
	{
		path: RoutePath.user.email,
		name: PageName.User.Email,
		component: () => import('@/views/user/UserChangeEmail.vue'),
	},
	{
		path: RoutePath.user.phone,
		name: PageName.User.Phone,
		component: () => import('@/views/user/UserChangePhone.vue'),
	},
	{
		path: RoutePath.user.pw,
		name: PageName.User.Pw,
		component: () => import('@/views/user/UserChangePw.vue'),
	},
	{
		path: RoutePath.user.noticeSetting,
		name: PageName.User.NoticeSetting,
		component: () => import('@/views/user/NoticeSetting.vue'),
	},
	{
		path: RoutePath.user.language,
		name: PageName.User.Language,
		component: () => import('@/views/user/LngSetting.vue'),
	},
	{
		path: RoutePath.dashboard,
		name: PageName.Dashboard,
		component: () => import('@/views/dashboard/Index.vue'),
	},
	// {
	// 	path: RoutePath.inventory.list,
	// 	name: PageName.Inventory.List,
	// 	component: () => import('@/views/inventory/Index.vue'),
	// },
	{
		path: RoutePath.inventory.list,
		name: PageName.Inventory.List,
		component: () => import('@/views/inventory2/pages/list.vue'),
	},
	{
		path: RoutePath.bundle,
		name: PageName.Inventory.BundleList,
		component: () =>
			import('@/views/inventory/pages/InventoryBundleList.vue'),
	},
	{
		path: RoutePath.inventory.beingRegisteredList,
		name: PageName.Inventory.BeingRegisteredList,
		// component: () =>
		// 	import(
		// 		'@/views/inventory/beingRegisted/InventoryBeingRegisterList.vue'
		// 	),
		component: () => import('@/views/inventory2/pages/InspectList.vue'),
	},
	{
		path: RoutePath.inventory.analyzingItem,
		name: PageName.Inventory.AnalyzingItem,
		component: () =>
			import('@/views/inventory/beingRegisted/AnalizingItem.vue'),
	},
	{
		path: RoutePath.inventory.expired,
		name: PageName.Inventory.Expired,
		component: () => import('@/views/inventory/InventoryExpired.vue'),
	},
	{
		path: RoutePath.inventory.safetyThreshold,
		name: PageName.Inventory.SafetyThreshold,
		component: () =>
			import('@/views/inventory/InventorySafetyThreshold.vue'),
	},
	{
		path: RoutePath.inventory.disposal,
		name: 'InventoryDisposal',
		component: () =>
			import('@/views/inventory/InventoryDeleteDisposal.vue'),
	},
	{
		path: RoutePath.inventory.deleteDisposal,
		name: 'InventoryDeleteDisposal',
		component: () =>
			import('@/views/inventory/InventoryDeleteDisposal.vue'),
	},
	{
		path: RoutePath.inventory.detail,
		name: 'InventoryItemDetail',
		component: () => import('@/views/inventory/InventoryItemDetail.vue'),
	},
	{
		path: RoutePath.inventory.registAsCasNo,
		name: 'InventoryRegistCasNo',
		component: () => import('@/views/inventory/InventorySearchCASNo.vue'),
	},
	{
		path: RoutePath.inventory.registInfo,
		name: 'InventoryFormRegist',
		component: () => import('@/views/inventory/InventoryFormRegist.vue'),
	},
	{
		path: RoutePath.inventory.registCount,
		name: 'InventoryRegistCount',
		component: () => import('@/views/inventory/InventoryRegistCount.vue'),
	},
	{
		path: RoutePath.inventory.inputUsage,
		name: 'InventoryInputUsage',
		component: () => import('@/views/inventory/InventoryInputUsage.vue'),
	},
	{
		path: RoutePath.inventory.divide,
		name: 'InventoryDivide',
		component: () => import('@/views/inventory/InventoryDivide.vue'),
	},
	{
		path: RoutePath.inventory.divideInfo,
		name: 'InventoryDivideInfo',
		component: () => import('@/views/inventory/InventoryDivideInfo.vue'),
	},
	{
		path: RoutePath.inventory.editDetailInfo,
		name: 'InventoryDivideDetailInfo',
		component: () =>
			import('@/views/inventory/InventoryDivideDetailInfo.vue'),
	},
	{
		path: RoutePath.common.selectMember,
		name: 'CommonSelectMember',
		component: () => import('@/views/common/modals/ModalSelectMember.vue'),
	},
	{
		path: RoutePath.common.selectStorage,
		name: 'CommonSelectStorage',
		component: () => import('@/views/common/CommonSelectStorage.vue'),
	},
	{
		path: '/management/history',
		name: 'ManagementHistory',
		component: () => import('@/views/inventory/ManagementHistory.vue'),
	},
	{
		path: '/management/number',
		name: 'ManagementNumber',
		component: () => import('@/views/inventory/ManagementNumber.vue'),
	},
	{
		path: '/management/number/detail',
		name: 'ManagementNumberDetail',
		component: () => import('@/views/inventory/ManagementNumberDetail.vue'),
	},
	{
		path: '/management/guide',
		name: 'ManagementGuide',
		component: () => import('@/views/inventory/ManagementGuide.vue'),
	},
	{
		path: RoutePath.inventory.registType,
		name: 'InventoryRegistType',
		component: () => import('@/views/inventory/InventoryRegistType.vue'),
	},
	{
		path: '/inventory/ghs',
		name: 'InventoryGHS',
		component: () => import('@/views/inventory/InventoryGHS.vue'),
	},
	// {
	// 	path: RoutePath.inventory.history,
	// 	name: 'InventoryHistory',
	// 	component: () => import('@/views/inventory/pages/InventoryHistory.vue'),
	// },
	{
		path: RoutePath.inventory.history,
		name: 'InventoryHistory',
		component: () => import('@/views/inventory2/pages/history.vue'),
	},
	{
		path: '/item/info/cas',
		name: 'InventorySearchCASNo',
		component: () => import('@/views/inventory/InventorySearchCASNo.vue'),
	},
	{
		path: '/item/add',
		name: 'InventoryRegistration',
		component: () => import('@/views/inventory/InventoryFormRegist.vue'),
	},
	{
		path: RoutePath.inventory.registComplete,
		name: 'InventoryRegistComplete',
		component: () =>
			import('@/views/inventory/InventoryRegistComplete.vue'),
	},
	{
		path: RoutePath.inventory.inputReason,
		name: 'InputReason',
		component: () => import('@/views/common/components/InputReason.vue'),
	},
	{
		path: RoutePath.inventory.registSearch,
		name: 'InventorySearchProduct',
		component: () => import('@/views/inventory/InventorySearchProduct.vue'),
	},
	{
		path: RoutePath.inventory.inputIngredient,
		name: 'InventoryInputIngredient',
		component: () =>
			import('@/views/inventory/InventoryFormIngredient.vue'),
	},
	{
		path: RoutePath.inventory.brandList,
		name: 'InventorySearchBrandList',
		component: () =>
			import('@/views/inventory/pages/InventorySearchBrandList'),
	},
	{
		path: RoutePath.inventory.brandForm,
		name: 'InventoryFormBrand',
		component: () => import('@/views/inventory/pages/InventoryFormBrand'),
	},
	{
		path: RoutePath.inventory.formRegistDetail,
		name: 'InventoryFormRegistDetail',
		component: () =>
			import('@/views/inventory/pages/InventoryFormRegistDetail'),
	},
	{
		path: '/reason/usage',
		name: 'UsageReason',
		component: () => import('@/views/common/components/UsageReason.vue'),
	},
	{
		path: RoutePath.institution.main,
		name: PageName.Institution.Main,
		component: () => import('@/views/institution/Index.vue'),
	},
	{
		path: RoutePath.institution.info,
		name: PageName.Institution.Info,
		component: () => import('@/views/institution/InstitutionInfo.vue'),
	},
	{
		path: RoutePath.institution.orgainzation,
		name: PageName.Institution.Organization,
		component: () =>
			import('@/views/institution/InstitutionOrganization.vue'),
	},
	{
		path: RoutePath.institution.groupinfo,
		name: PageName.Institution.Groupinfo,
		component: () => import('@/views/institution/InstitutionGroupInfo.vue'),
	},
	{
		path: RoutePath.institution.memberinfo,
		name: PageName.Institution.Memberinfo,
		component: () =>
			import('@/views/institution/InstitutionMemberInfo.vue'),
	},
	{
		path: RoutePath.institution.location,
		name: PageName.Institution.Location,
		component: () => import('@/views/institution/InstitutionLocation.vue'),
	},
	{
		path: RoutePath.institution.storageinfo,
		name: PageName.Institution.StorageInfo,
		component: () =>
			import('@/views/institution/InstitutionStorageInfo.vue'),
	},
	{
		path: RoutePath.institution.storageList,
		name: PageName.Institution.StorageList,
		component: () =>
			import('@/views/institution/InstitutionStorageList.vue'),
	},
	{
		path: RoutePath.institution.subStorage,
		name: PageName.Institution.SubStorage,
		component: () =>
			import('@/views/institution/InstitutionSubStorage.vue'),
	},
	{
		path: RoutePath.institution.storageInventory,
		name: PageName.Institution.StorageInventory,
		component: () =>
			import('@/views/institution/InstitutionStorageInventory.vue'),
	},
	{
		path: RoutePath.safety.main,
		name: PageName.Safety.Main,
		component: () => import('@/views/safety/Index.vue'),
	},
	{
		path: RoutePath.safety.msds,
		name: PageName.Safety.Msds,
		component: () => import('@/views/safety/SafetyMsdsList.vue'),
	},
	{
		path: RoutePath.safety.msdsDetail,
		name: PageName.Safety.MsdsDetail,
		component: () => import('@/views/safety/SafetyMsdsDetail.vue'),
	},
	{
		path: RoutePath.safety.specialManagement,
		name: PageName.Safety.SpecialManagement,
		component: () => import('@/views/safety/SafetySpecialManagement.vue'),
	},
	{
		path: RoutePath.safety.specialManagementList,
		name: PageName.Safety.SpecialManagementList,
		component: () =>
			import('@/views/safety/SafetySpecialManagementList.vue'),
	},
	{
		path: '/safety/ghs',
		name: 'SafetyGhs',
		component: () => import('@/views/safety/SafetyGhs.vue'),
	},
	{
		path: RoutePath.safety.dangerous,
		name: PageName.Safety.DangerousStorage,
		component: () => import('@/views/safety/SafetyDangerStorage.vue'),
	},
	{
		path: RoutePath.safety.dangerousSub,
		name: PageName.Safety.DangerousStorageSub,
		component: () => import('@/views/safety/SafetyDangerStorageSub.vue'),
	},
	{
		path: RoutePath.safety.dangerousDetail,
		name: PageName.Safety.DangerousStorageDetail,
		component: () => import('@/views/safety/SafetyDangerProductDetail.vue'),
	},
	{
		path: RoutePath.safety.hazardousMaterial,
		name: PageName.Safety.HazardousMaterial,
		component: () => import('@/views/safety/SafetyHazardousMaterial.vue'),
	},
	{
		path: '/safety/hazard/detail',
		name: 'SafetyHazardousMaterialDetail',
		component: () =>
			import('@/views/safety/SafetyHazardousMaterialDetail.vue'),
	},
	{
		path: RoutePath.safety.management,
		name: PageName.Safety.SafetyManagement,
		component: () => import('@/views/safety/SafetyManagement.vue'),
	},
	{
		path: '/safety/management/detail',
		name: 'SafetyManagementDetail',
		component: () => import('@/views/safety/SafetyManagementDetail.vue'),
	},
	{
		path: RoutePath.management.menu,
		name: PageName.Management.Menu,
		component: () =>
			import('@/views/common/modals/management/ModalManagement.vue'),
	},
	{
		path: RoutePath.safety.healthCheck,
		name: PageName.Safety.HealthCheck,
		component: () => import('@/views/safety/SafetyHealthCheckupList.vue'),
	},
	{
		path: RoutePath.safety.healthCheckupDetail,
		name: PageName.Safety.HealthCheckupDetail,
		component: () => import('@/views/safety/SafetyHealthCheckupDetail.vue'),
	},
	{
		path: RoutePath.safety.healthCheckupHistory,
		name: PageName.Safety.HealthCheckupHistory,
		component: () =>
			import('@/views/safety/SafetyHealthCheckupHistory.vue'),
	},
	{
		path: RoutePath.safety.healthCheckupUsageHistory,
		name: PageName.Safety.HealthCheckupUsageHistory,
		component: () =>
			import('@/views/safety/SafetyHealthCheckupMaterial.vue'),
	},
	{
		path: '/safety/law',
		name: 'SafetyLawMaterial',
		component: () => import('@/views/safety/SafetyLawProductByGroup.vue'),
	},
	{
		path: RoutePath.inventory.itemCreate,
		name: PageName.Inventory.ItemCreate,
		component: () => import('@/views/inventory/create/InventoryItemCreate'),
	},
	{
		path: RoutePath.inventory.itemCreateCamera,
		name: PageName.Inventory.ItemCreateCamera,
		component: () =>
			import('@/views/inventory/create/pages/step1/Camera.vue'),
	},
	{
		path: RoutePath.safety.dangerousInventoryList,
		name: PageName.Safety.DangerousInventoryList,
		component: () =>
			import(
				/* webpackChunkname: dangerousInventoryList */ '@/views/safety/LegalInventoryList.vue'
			),
	},
	{
		path: RoutePath.safety.hazardousMaterialList,
		name: PageName.Safety.HazardousMaterialList,
		component: () =>
			import(
				/* webpackChunkname: hazardouseMaterialList */ '@/views/safety/SafetyHazardousMaterialList.vue'
			),
	},
	{
		path: RoutePath.safety.lawProductByGroup,
		name: PageName.Safety.LawProductByGroup,
		component: () =>
			import(
				/* webpackChunkname: lawProductByGroup */ '@/views/safety/SafetyLawProductByGroup.vue'
			),
	},
	{
		path: RoutePath.safety.lawProductByGroupItem,
		name: PageName.Safety.LawProductByGroupItem,
		component: () =>
			import(
				/* webpackChunkname: lawProductByGroupItem */ '@/views/safety/LawProductByGroupItem.vue'
			),
	},
	{
		path: RoutePath.GlobalFilter,
		name: PageName.GlobalFilter,
		component: () => import('@/views/globalFilter/index.vue'),
	},
]

routes = routes.concat(InviteRoutes)
routes = routes.concat(CargoRoutes)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: routes,
})

// router.beforeEach(async (to, from, next) => {
//     const token = to.query.token
//     // SSO를 통해 로그인한 경우
//     if (token) {
//         setToken(token)
//         axiosConfig.initAxios()
//         userAPI.lookupUserInstInfo().then(response => {
//             const { data } = response
//             router.replace({name: PageName.Dashboard, params: {instituteId: data.id}})
//             next()
//         })
//     } else {
//         // 토큰이 있는 경우
//         if (isLogin()) {
//             const isToHome = to.name === 'Home'
//             if (isToHome) {
//                 axiosConfig.initAxios()
//                 userAPI.lookupUserInstInfo().then(response => {
//                     const { data } = response
//                     // next(`/${data.id}/dashboard`)
//                     router.replace({name: PageName.Dashboard, params: {instituteId: data.id}})
//                     next()
//                 })
//             } else {
//                 next()
//             }
//         } else {
//             // 토큰이 없는 경우나 만료된 경우에는 SSO 페이지로 replace
//             location.replace(RoutePath.sso)
//         }
//     }
//     window.scrollTo(0, 0)
// })

export default router
